var _path, _path2, _path3, _path4, _path5, _g, _path6, _g2, _path7, _g3, _path8, _g4, _path9, _g5, _path10, _g6, _path11, _g7, _path12, _g8, _path13, _g9, _path14, _g10, _path15, _g11, _path16, _g12, _path17, _g13, _path18, _g14, _path19, _g15, _path20, _g16, _path21, _g17, _path22, _g18, _path23, _g19, _path24, _path25, _g20, _path26, _g21, _path27, _g22, _path28, _g23, _path29, _g24, _path30, _path31, _path32, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeetNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 260,
    viewBox: "0 0 250 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221.023 223.435C215.889 229.028 211.03 232.636 207.197 235.484C162.09 268.986 108.708 259.219 97.3604 256.835C80.6047 253.311 48.2264 246.503 24.8146 218.009C-10.6086 174.889 -5.0853 106.957 22.3805 62.1204C27.408 53.9211 53.9533 8.38902 107.902 1.08941C140.564 -3.3256 178.625 5.5879 206.188 29.4902C264.04 79.6692 259.924 181.038 221.023 223.435Z",
    fill: "#E1EBEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4648 240.289H98.5598V174.066H92.4648V240.289Z",
    fill: "#31667F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8203 241.578H122.202V237.881C122.202 237.721 122.073 237.592 121.915 237.592H69.1296C68.9586 237.592 68.8203 237.731 68.8203 237.903V241.578Z",
    fill: "#31667F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7266 171.628C58.7266 175.476 61.8613 178.625 65.6919 178.625H123.091C126.922 178.625 130.057 175.476 130.057 171.628V165.299C130.057 161.45 126.922 158.301 123.091 158.301H65.6919C61.8613 158.301 58.7266 161.45 58.7266 165.299V171.628Z",
    fill: "#31667F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7084_3627",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 225,
    width: 24,
    height: 25
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.464 228.576C129.464 228.576 146.868 241.18 143.846 249.648C143.846 249.648 124.803 241.394 122.503 234.891C120.202 228.389 122.892 225.517 122.892 225.517L129.464 228.576Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7084_3627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.463 228.576C129.463 228.576 146.867 241.18 143.846 249.648C143.846 249.648 124.803 241.394 122.503 234.891C120.202 228.389 122.892 225.517 122.892 225.517L129.463 228.576Z",
    fill: "#163949"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7084_3627",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 218,
    width: 12,
    height: 13
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.85 218.025L124.004 226.291C123.574 227.538 124.004 228.959 125.114 229.664C125.671 230.017 126.431 230.343 127.47 230.58C128.936 230.913 130.449 230.234 131.154 228.9L134.559 222.459L126.85 218.025Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7084_3627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.849 218.025L124.004 226.291C123.575 227.538 124.004 228.959 125.115 229.664C125.67 230.017 126.43 230.343 127.47 230.58C128.935 230.913 130.449 230.234 131.154 228.9L134.559 222.459L126.849 218.025Z",
    fill: "url(#paint0_linear_7084_3627)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7084_3627",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 143,
    width: 64,
    height: 81
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1586 143.613C99.1586 143.613 134.906 149.838 150.241 164.071C165.575 178.303 136.166 223.703 136.166 223.703C136.166 223.703 131.348 223.673 125.508 218.645C125.508 218.645 142.946 184.5 127.918 174.543C111.023 163.349 91.5527 160.827 91.5527 160.827L98.8129 144.711L99.1586 143.613Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7084_3627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.1588 143.614C99.1588 143.614 134.906 149.839 150.241 164.07C165.575 178.303 136.165 223.703 136.165 223.703C136.165 223.703 131.347 223.673 125.508 218.645C125.508 218.645 142.945 184.5 127.918 174.543C111.022 163.349 91.5527 160.828 91.5527 160.828L98.8126 144.712L99.1588 143.614Z",
    fill: "url(#paint1_linear_7084_3627)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_7084_3627",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 235,
    width: 30,
    height: 18
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M140.813 244.949C136.984 243.169 126.147 235.548 124.321 235.212C122.494 234.876 119.325 237.032 119.325 237.032C119.325 237.032 118.554 238.425 119.379 240.854C121.923 243.946 127.57 249.841 135.163 252.038C140.748 253.654 144.655 252.147 147.088 250.385C145.749 248.336 143.363 246.135 140.813 244.949Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_7084_3627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.813 244.949C136.985 243.169 126.147 235.548 124.321 235.212C122.495 234.876 119.326 237.032 119.326 237.032C119.326 237.032 118.555 238.425 119.378 240.854C121.923 243.946 127.57 249.841 135.163 252.038C140.748 253.654 144.655 252.147 147.088 250.385C145.75 248.336 143.363 246.135 140.813 244.949Z",
    fill: "#31667F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_7084_3627",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 240,
    width: 30,
    height: 16
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M135.173 252.055C127.58 249.859 121.933 243.964 119.389 240.871C119.946 242.513 121.23 244.627 123.976 247.106C130.783 253.253 143.785 255.469 146.552 255.043C148.771 254.701 148.562 252.643 147.098 250.403C144.665 252.165 140.758 253.672 135.173 252.055Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_7084_3627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.173 252.055C127.581 249.859 121.933 243.964 119.389 240.871C119.946 242.513 121.231 244.627 123.976 247.106C130.784 253.253 143.786 255.469 146.553 255.043C148.772 254.7 148.562 252.643 147.098 250.403C144.665 252.165 140.758 253.672 135.173 252.055Z",
    fill: "#163949"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_7084_3627",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 116,
    y: 228,
    width: 11,
    height: 12
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M116.084 231.68C116.127 232.74 118.283 236.373 119.543 238.412C120.141 239.381 121.19 239.973 122.325 239.977C123.046 239.979 123.873 239.915 124.624 239.698C125.753 239.373 126.386 238.166 126.056 237.034L123.594 228.588L116.084 231.68Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_7084_3627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.084 231.68C116.128 232.74 118.284 236.373 119.544 238.412C120.142 239.381 121.19 239.973 122.326 239.977C123.046 239.979 123.873 239.915 124.625 239.698C125.753 239.373 126.387 238.166 126.057 237.034L123.594 228.588L116.084 231.68Z",
    fill: "url(#paint2_linear_7084_3627)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_7084_3627",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 132,
    width: 66,
    height: 103
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.747 132.804C64.747 132.804 56.8085 154.132 64.747 160.617C72.6854 167.104 91.6245 174.406 95.8558 187.325C100.086 200.244 107.266 225.351 116.873 234.242C116.873 234.242 123.624 233.585 126.15 230.882C126.15 230.882 120.678 193.401 117.07 183.785C113.944 175.456 109.339 163.435 100.514 156.717C97.9886 154.792 98.4281 151.746 99.5993 148.787L101.733 143.399L64.747 132.804Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_7084_3627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.7467 132.804C64.7467 132.804 56.8088 154.132 64.7467 160.618C72.6856 167.104 91.6248 174.407 95.8564 187.326C100.086 200.244 107.266 225.351 116.874 234.242C116.874 234.242 123.625 233.585 126.15 230.882C126.15 230.882 120.679 193.402 117.07 183.785C113.944 175.457 109.34 163.435 100.515 156.717C97.989 154.792 98.4283 151.747 99.5994 148.787L101.733 143.399L64.7467 132.804Z",
    fill: "url(#paint3_linear_7084_3627)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_7084_3627",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 94,
    width: 30,
    height: 34
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M147.53 116.124C134.218 116.93 138.365 95.5629 138.605 94.7133L118.402 109.051C118.402 109.051 119.472 120.477 136.269 126.47C140.519 127.987 144.403 128.054 147.837 127.313C146.372 123.022 146.671 119.172 147.53 116.124Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_7084_3627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.529 116.124C134.218 116.93 138.365 95.5634 138.605 94.7135L118.402 109.051C118.402 109.051 119.471 120.477 136.269 126.471C140.519 127.987 144.403 128.054 147.837 127.313C146.372 123.022 146.67 119.172 147.529 116.124Z",
    fill: "url(#paint4_linear_7084_3627)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_7084_3627",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 108,
    width: 36,
    height: 20
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M173.276 109.66C168.315 106.194 162.696 109.66 162.696 109.66C156.064 114.019 151.157 115.872 147.538 116.092C146.679 119.14 146.381 122.99 147.845 127.281C155.276 125.676 160.592 120.273 162.901 117.502C163.732 116.503 165.205 116.33 166.222 117.136C167.255 117.955 168.258 119.077 168.075 120.258C167.718 122.587 170.407 123.328 170.609 122.483C170.813 121.639 169.69 116.632 169.69 116.632C169.69 116.632 175.07 122.067 177.169 124.155C179.27 126.244 181.91 124.155 181.91 124.155C181.91 124.155 178.236 113.128 173.276 109.66Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_7084_3627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.276 109.66C168.316 106.193 162.697 109.66 162.697 109.66C156.064 114.018 151.158 115.872 147.538 116.091C146.679 119.14 146.381 122.989 147.845 127.281C155.275 125.676 160.591 120.273 162.901 117.501C163.733 116.502 165.205 116.329 166.222 117.135C167.255 117.955 168.258 119.077 168.076 120.258C167.718 122.587 170.408 123.327 170.609 122.482C170.814 121.638 169.69 116.631 169.69 116.631C169.69 116.631 175.07 122.066 177.169 124.154C179.27 126.243 181.911 124.154 181.911 124.154C181.911 124.154 178.237 113.127 173.276 109.66Z",
    fill: "url(#paint5_linear_7084_3627)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_7084_3627",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 60,
    width: 80,
    height: 85
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4741 61.7099C85.4741 61.7099 104.84 53.9202 140.879 83.8149C140.879 83.8149 143.89 90.0753 140.606 95.6472C137.321 101.22 106.031 128.371 101.73 143.429C101.73 143.429 83.0873 149.515 63.8086 135.083C63.8086 135.083 65.51 93.1772 85.4741 61.7099Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_7084_3627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.4743 61.7106C85.4743 61.7106 104.84 53.921 140.879 83.8155C140.879 83.8155 143.889 90.0758 140.606 95.6474C137.321 101.22 106.032 128.372 101.73 143.429C101.73 143.429 83.0874 149.515 63.8086 135.083C63.8086 135.083 65.5101 93.1772 85.4743 61.7106Z",
    fill: "url(#paint6_linear_7084_3627)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_7084_3627",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 54,
    width: 24,
    height: 23
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M123.757 54.7494L114.224 66.3609C113.277 67.5144 113.069 69.1175 113.723 70.4593C115.046 73.1723 118.186 77.1197 125.149 76.5739C127.22 76.4119 129.054 75.1561 129.96 73.2766L136.625 59.4321L123.757 54.7494Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_7084_3627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.757 54.749L114.224 66.3606C113.278 67.5141 113.068 69.1165 113.723 70.4589C115.047 73.1725 118.186 77.1197 125.149 76.5739C127.221 76.4122 129.055 75.1559 129.959 73.2768L136.625 59.4323L123.757 54.749Z",
    fill: "url(#paint7_linear_7084_3627)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_7084_3627",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 61,
    width: 46,
    height: 69
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4791 111.406C68.2304 102.207 91.0016 81.6986 91.0016 81.6986L85.4721 61.6747C85.4721 61.6747 36.3008 94.5628 48.8313 121.011C50.6277 124.803 53.0135 127.458 55.7796 129.234C59.7386 118.526 66.0493 113.616 70.4791 111.406Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_7084_3627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.479 111.406C68.2303 102.206 91.0016 81.6978 91.0016 81.6978L85.472 61.6743C85.472 61.6743 36.3009 94.5626 48.8313 121.01C50.6277 124.802 53.0136 127.457 55.7796 129.234C59.7386 118.526 66.0492 113.615 70.479 111.406Z",
    fill: "url(#paint8_linear_7084_3627)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_7084_3627",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 79,
    width: 23,
    height: 32
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4645 110.102C70.2236 110.102 70.0038 109.936 69.9434 109.69C67.6443 100.285 89.6908 80.298 90.6302 79.4514C90.8509 79.2529 91.1906 79.2712 91.3902 79.493C91.5887 79.7157 91.5696 80.057 91.3488 80.2565C91.1231 80.4591 68.8417 100.652 70.9886 109.432C71.0591 109.722 70.8828 110.015 70.5935 110.086C70.5511 110.096 70.5078 110.102 70.4645 110.102Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_7084_3627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.4645 110.102C70.2236 110.102 70.0039 109.937 69.9434 109.691C67.6443 100.284 89.6909 80.2974 90.6302 79.4508C90.8509 79.2534 91.191 79.2711 91.3901 79.493C91.5892 79.7162 91.5703 80.0564 91.3495 80.2565C91.1232 80.4593 68.8417 100.651 70.9887 109.432C71.0592 109.722 70.8828 110.016 70.5935 110.087C70.5512 110.096 70.5079 110.102 70.4645 110.102Z",
    fill: "#A0CDDF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_7084_3627",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 39,
    width: 24,
    height: 30
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M147.543 41.3565C147.543 41.3565 147.708 54 145.674 59.7419C143.641 65.4849 143.322 69.6329 136.393 68.0389C129.464 66.445 125.375 60.9187 124.763 54.0871C124.763 54.0871 123.744 43.5267 126.254 40.436C128.764 37.3463 147.543 41.3565 147.543 41.3565Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_7084_3627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.543 41.3554C147.543 41.3554 147.707 53.9992 145.673 59.7411C143.641 65.4846 143.323 69.6328 136.393 68.039C129.464 66.4453 125.375 60.9187 124.763 54.0859C124.763 54.0859 123.744 43.5259 126.255 40.4349C128.764 37.3454 147.543 41.3554 147.543 41.3554Z",
    fill: "#FFABAA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_7084_3627",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 29,
    width: 40,
    height: 27
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M128.64 50.9979L129.457 51.3422C129.457 51.3422 128.989 42.9925 132.453 43.0209C135.918 43.0503 148.627 45.5891 152.896 42.4811C157.013 39.4846 157.013 33.372 154.371 30.5466C154.205 30.3683 153.921 30.3633 153.733 30.5182L153.249 30.9172C152.918 31.1896 152.426 30.9192 152.475 30.4919C152.522 30.0868 152.071 29.8042 151.739 30.0402C150.445 30.9618 147.504 32.1081 141.453 30.7805C132.869 28.8979 126.248 29.9157 123.806 35.3933C123.652 35.7407 123.199 35.7761 122.977 35.4682C122.538 34.8596 121.669 34.2935 119.966 34.8262C117.006 35.7518 115.898 40.9236 119.046 46.8904C119.195 47.1739 119.044 47.5304 118.729 47.5881C117.623 47.7897 115.762 48.5958 118.367 51.8161C121.03 55.1104 123.148 55.7666 123.997 55.8932C124.226 55.9266 124.443 55.797 124.52 55.5773L126.267 50.5472C126.357 50.287 126.648 50.1573 126.901 50.2647L128.64 50.9979Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_7084_3627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.64 50.998L129.457 51.3424C129.457 51.3424 128.99 42.9929 132.454 43.0212C135.917 43.0494 148.626 45.5886 152.897 42.4804C157.013 39.4837 157.013 33.3721 154.371 30.5467C154.204 30.367 153.921 30.362 153.734 30.5184L153.25 30.9161C152.919 31.189 152.425 30.9194 152.475 30.4918C152.523 30.0858 152.071 29.8029 151.74 30.0392C150.444 30.961 147.503 32.1075 141.453 30.7797C132.868 28.8978 126.247 29.9144 123.806 35.3921C123.652 35.7398 123.198 35.7748 122.976 35.4669C122.539 34.8596 121.668 34.2922 119.966 34.8263C117.006 35.7515 115.898 40.9229 119.046 46.8898C119.195 47.1726 119.044 47.5304 118.729 47.587C117.623 47.79 115.762 48.5953 118.367 51.815C121.03 55.1096 123.149 55.7668 123.996 55.8933C124.225 55.9265 124.444 55.7968 124.52 55.5771L126.267 50.5471C126.358 50.2858 126.648 50.1561 126.901 50.2642L128.64 50.998Z",
    fill: "#14262F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_7084_3627",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 45,
    width: 6,
    height: 10
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M128.409 52.0954C128.409 52.0954 129.496 44.5215 125.649 45.1504C121.8 45.7793 124.032 53.4687 126.375 54.7578L128.409 52.0954Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_7084_3627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.409 52.0956C128.409 52.0956 129.496 44.5222 125.649 45.1504C121.8 45.7802 124.032 53.4699 126.376 54.7578L128.409 52.0956Z",
    fill: "url(#paint9_linear_7084_3627)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_7084_3627",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 110,
    width: 73,
    height: 23
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M104.962 110.655C104.962 110.655 77.9639 121.186 71.374 113.264C70.9275 112.727 70.6362 112.115 70.4729 111.447C66.0431 113.656 59.7324 118.567 55.7734 129.275C69.973 138.391 94.244 124.204 100.807 120.021C101.886 119.332 103.181 119.091 104.433 119.352C106.965 119.879 111.338 120.655 113.696 120.289C117.146 119.756 122.101 131.983 127.693 128.212C127.693 128.212 122.905 106.958 104.962 110.655Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_7084_3627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.963 110.655C104.963 110.655 77.9642 121.186 71.374 113.264C70.9275 112.726 70.6362 112.114 70.473 111.447C66.0431 113.656 59.7324 118.566 55.7734 129.275C69.9731 138.391 94.2445 124.204 100.807 120.021C101.887 119.332 103.181 119.091 104.433 119.351C106.965 119.879 111.338 120.655 113.697 120.289C117.147 119.755 122.101 131.983 127.694 128.212C127.694 128.212 122.905 106.958 104.963 110.655Z",
    fill: "url(#paint10_linear_7084_3627)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_7084_3627",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 116,
    y: 126,
    width: 63,
    height: 6
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M118.801 131.387C118.844 131.39 118.887 131.391 118.931 131.39L175.577 131.328C176.977 131.327 178.111 130.185 178.11 128.779C178.108 127.371 176.968 126.208 175.571 126.234L118.926 126.296C117.524 126.297 116.391 127.439 116.393 128.845C116.394 130.208 117.461 131.321 118.801 131.387Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_7084_3627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.8 131.387C118.844 131.39 118.886 131.391 118.93 131.39L175.577 131.328C176.977 131.328 178.111 130.185 178.109 128.779C178.108 127.371 176.968 126.208 175.57 126.235L118.925 126.296C117.525 126.298 116.39 127.439 116.393 128.846C116.393 130.209 117.46 131.321 118.8 131.387Z",
    fill: "url(#paint11_linear_7084_3627)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_7084_3627",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 149,
    y: 79,
    width: 82,
    height: 53
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M226.506 79.7161H179.329C175.85 79.7161 172.682 81.7334 171.197 84.896L149.389 131.359H208.015C210.258 131.359 212.273 129.983 213.097 127.888L230.009 84.892C230.986 82.4079 229.164 79.7161 226.506 79.7161Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_7084_3627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.507 79.7157H179.329C175.85 79.7157 172.683 81.733 171.198 84.8964L149.389 131.359H208.016C210.259 131.359 212.273 129.983 213.098 127.888L230.01 84.8913C230.987 82.4078 229.165 79.7157 226.507 79.7157Z",
    fill: "url(#paint12_linear_7084_3627)"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M193.259 103.549C192.235 106.742 192.992 109.84 194.946 110.473C196.9 111.104 199.312 109.03 200.335 105.838C201.357 102.648 200.602 99.5487 198.648 98.9161C196.693 98.285 194.281 100.359 193.259 103.549Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_7084_3627",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 176,
    y: 135,
    width: 56,
    height: 119
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M228.702 253.438C229.016 253.438 229.334 253.376 229.642 253.248C230.849 252.743 231.408 251.381 230.887 250.206L180.965 137.319C180.444 136.145 179.045 135.603 177.837 136.107C176.629 136.612 176.071 137.974 176.591 139.149L226.514 252.036C226.902 252.912 227.78 253.438 228.702 253.438Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_7084_3627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.702 253.438C229.015 253.438 229.334 253.376 229.642 253.248C230.85 252.743 231.408 251.381 230.887 250.206L180.965 137.319C180.445 136.145 179.046 135.603 177.837 136.107C176.629 136.612 176.07 137.974 176.592 139.149L226.514 252.036C226.902 252.912 227.78 253.438 228.702 253.438Z",
    fill: "#14262F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_7084_3627",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 170,
    y: 135,
    width: 55,
    height: 119
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M172.462 253.438C173.385 253.438 174.263 252.913 174.65 252.036L224.574 139.149C225.093 137.974 224.535 136.612 223.327 136.107C222.12 135.602 220.72 136.143 220.2 137.319L170.276 250.206C169.757 251.381 170.315 252.743 171.522 253.248C171.828 253.376 172.148 253.438 172.462 253.438Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_7084_3627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.462 253.438C173.385 253.438 174.263 252.913 174.65 252.036L224.574 139.149C225.092 137.975 224.535 136.613 223.328 136.107C222.121 135.602 220.72 136.143 220.201 137.319L170.276 250.206C169.757 251.381 170.314 252.743 171.521 253.248C171.829 253.376 172.148 253.438 172.462 253.438Z",
    fill: "#14262F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_7084_3627",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 135,
    width: 56,
    height: 119
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1653 253.438C74.4788 253.438 74.7973 253.376 75.1047 253.248C76.3122 252.743 76.8696 251.381 76.3505 250.206L26.4271 137.319C25.9076 136.145 24.5089 135.603 23.2998 136.107C22.0921 136.612 21.5342 137.974 22.0538 139.149L71.9771 252.036C72.3642 252.912 73.2421 253.438 74.1653 253.438Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_7084_3627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.1657 253.438C74.4784 253.438 74.7972 253.376 75.1049 253.248C76.3124 252.743 76.8693 251.381 76.3507 250.206L26.4271 137.319C25.9076 136.145 24.5089 135.602 23.2998 136.107C22.0921 136.612 21.5341 137.974 22.0538 139.149L71.9776 252.036C72.364 252.912 73.2426 253.438 74.1657 253.438Z",
    fill: "#14262F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_7084_3627",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 135,
    width: 56,
    height: 119
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9325 253.422C18.8551 253.422 19.733 252.897 20.1204 252.02L70.0439 139.134C70.563 137.959 70.0056 136.597 68.7981 136.091C67.5906 135.586 66.1906 136.128 65.6705 137.304L15.7471 250.19C15.2275 251.365 15.7854 252.727 16.993 253.233C17.2995 253.36 17.6188 253.422 17.9325 253.422Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_7084_3627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9325 253.422C18.8552 253.422 19.733 252.897 20.1205 252.02L70.0437 139.133C70.5632 137.958 70.0054 136.596 68.7978 136.091C67.5903 135.586 66.1911 136.128 65.6706 137.304L15.7471 250.19C15.2275 251.365 15.7855 252.727 16.993 253.232C17.2996 253.36 17.6188 253.422 17.9325 253.422Z",
    fill: "#14262F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_7084_3627",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 130,
    width: 228,
    height: 14
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M238.147 143.25H15.8339C14.5838 143.25 13.5095 142.252 13.272 140.872L12.0702 133.887C11.9428 133.146 12.1162 132.381 12.5429 131.798C12.9695 131.217 13.6049 130.88 14.2754 130.88H231.499C232.808 135.67 235.472 139.895 239.053 143.113C238.762 143.202 238.458 143.25 238.147 143.25Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_7084_3627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.147 143.25H15.8338C14.5838 143.25 13.5095 142.252 13.272 140.872L12.0703 133.887C11.9428 133.146 12.1162 132.381 12.5428 131.798C12.9696 131.217 13.6049 130.88 14.2755 130.88H231.499C232.809 135.67 235.473 139.895 239.052 143.113C238.762 143.202 238.457 143.25 238.147 143.25Z",
    fill: "#14262F"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M169.596 43.4294C169.596 31.4676 179.194 21.772 190.713 21.7735C201.891 21.7751 210.714 30.9595 210.714 42.289C210.714 53.6178 201.891 63.2921 190.713 63.9137C179.194 64.5543 169.596 55.3904 169.596 43.4294Z",
    fill: "#A0CDDF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M200.183 51.4428L198.413 53.1024C197.921 53.5634 196.966 53.4018 196.281 52.7676L179.137 36.8765C178.781 36.5491 178.594 36.1782 178.532 35.777C178.469 35.3757 178.637 35.0666 178.908 34.8432L182.143 32.1737C182.408 31.956 182.75 31.8334 183.173 31.929C183.599 32.0217 183.996 32.246 184.314 32.5875L199.917 49.4139C200.542 50.0851 200.669 50.9875 200.183 51.4428Z",
    fill: "#31667F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M181.243 53.1827L179.583 51.4131C179.122 50.9207 179.284 49.9664 179.918 49.2805L195.809 32.1373C196.136 31.7811 196.507 31.5941 196.909 31.5317C197.31 31.4693 197.619 31.637 197.842 31.9076L200.512 35.1428C200.73 35.4077 200.852 35.7503 200.757 36.1733C200.664 36.5992 200.44 36.9957 200.098 37.3143L183.272 52.9172C182.6 53.5425 181.698 53.6694 181.243 53.1827Z",
    fill: "#31667F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7084_3627",
    x1: 139.248,
    y1: 217.323,
    x2: 150.946,
    y2: 217.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7084_3627",
    x1: 114.676,
    y1: 149.38,
    x2: 138.079,
    y2: 216.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14262F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31667F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7084_3627",
    x1: 122.557,
    y1: 231.59,
    x2: 133.021,
    y2: 231.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7084_3627",
    x1: 98.1148,
    y1: 224.823,
    x2: 100.751,
    y2: 135.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#31667F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#14262F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7084_3627",
    x1: 103.783,
    y1: 101.683,
    x2: 152.618,
    y2: 127.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31667F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7084_3627",
    x1: 219.551,
    y1: 48.0558,
    x2: 267.962,
    y2: 48.0558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7084_3627",
    x1: 77.5269,
    y1: 107.496,
    x2: 142.315,
    y2: 79.3636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31667F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7084_3627",
    x1: 155.856,
    y1: -18.0215,
    x2: 222.465,
    y2: -58.4092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7084_3627",
    x1: 47.4226,
    y1: 112.63,
    x2: 91.1783,
    y2: 72.8952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31667F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7084_3627",
    x1: 246.577,
    y1: -95.3794,
    x2: 192.286,
    y2: -81.2574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7084_3627",
    x1: 119.769,
    y1: 89.4448,
    x2: 15.9207,
    y2: 269.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7084_3627",
    x1: 98.6586,
    y1: 121.673,
    x2: 155.668,
    y2: 128.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14262F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#31667F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_7084_3627",
    x1: 181.289,
    y1: 79.783,
    x2: 215.453,
    y2: 131.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31667F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14262F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetNotFound);
export default __webpack_public_path__ + "static/media/meet-not-found.822115536a50b109ddf1c98ec76e14a9.svg";
export { ForwardRef as ReactComponent };